var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 26,
    fill: "none",
    viewBox: "0 0 40 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v26H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8CD",
    d: "M2 13c0-3.05 0-4.58.75-5.66.3-.43.66-.8 1.09-1.1 1.08-.74 2.6-.74 5.66-.74h20.65c3.05 0 4.57 0 5.66.75.43.3.8.66 1.09 1.09.75 1.08.75 2.6.75 5.66 0 3.05 0 4.58-.75 5.66-.3.43-.66.8-1.09 1.1-1.09.74-2.61.74-5.66.74H9.5c-3.05 0-4.58 0-5.66-.75-.43-.3-.8-.66-1.1-1.09C2 17.58 2 16.06 2 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B051D",
    d: "M30.72 15.08c-.62 0-1.1-.51-1.1-1.14 0-.62.48-1.14 1.1-1.14.63 0 1.11.52 1.11 1.14 0 .63-.48 1.14-1.1 1.14Zm-.3 1.2c.52 0 1.2-.2 1.58-.99l.03.02c-.16.43-.16.69-.16.75v.1h1.33v-4.44h-1.33v.1c0 .07 0 .32.16.75l-.03.02a1.68 1.68 0 0 0-1.59-.99c-1.27 0-2.16 1.01-2.16 2.34 0 1.33.9 2.34 2.16 2.34Zm-4.5-4.68c-.6 0-1.08.21-1.46 1l-.04-.03c.17-.43.17-.68.17-.75v-.1h-1.34v4.45h1.37v-2.35c0-.61.36-1 .94-1 .57 0 .86.33.86 1v2.35h1.37v-2.83c0-1.01-.79-1.74-1.87-1.74Zm-4.65 1-.04-.03c.16-.43.16-.68.16-.75v-.1h-1.33v4.45h1.37l.01-2.14c0-.63.33-1 .87-1 .15 0 .26.01.4.05v-1.36c-.6-.13-1.14.1-1.44.87Zm-4.37 2.48c-.62 0-1.1-.51-1.1-1.14 0-.62.48-1.14 1.1-1.14.63 0 1.11.52 1.11 1.14 0 .63-.48 1.14-1.1 1.14Zm-.3 1.2c.52 0 1.2-.2 1.58-.99l.03.02c-.16.43-.16.69-.16.75v.1h1.33v-4.44h-1.33v.1c0 .07 0 .32.16.75l-.03.02a1.68 1.68 0 0 0-1.59-.99c-1.27 0-2.16 1.01-2.16 2.34 0 1.33.9 2.34 2.16 2.34Zm-4.09-.11h1.38V9.74H12.5v6.43Zm-1-6.43h-1.4c0 1.14-.7 2.17-1.78 2.9l-.42.3v-3.2H6.46v6.43H7.9v-3.2l2.4 3.2h1.78l-2.31-3.05a4.08 4.08 0 0 0 1.73-3.38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35.66v15H0z",
    transform: "translate(2 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarna);
export default __webpack_public_path__ + "static/media/klarna.461be31a2a5fce13d5af6fdc0bf56825.svg";
export { ForwardRef as ReactComponent };